import Ionicons from "@expo/vector-icons/Ionicons";
import React from "react";
import {
  StyleProp,
  StyleSheet,
  TouchableOpacity,
  ViewStyle,
} from "react-native";
import { useThemeColor } from "@/hooks/useThemeColor";

// Vertical offset from the bottom edge. Callers on `(tabs)/…` screens land
// above the tab bar; other screens can pass `bottomOffset={20}` to sit flush.
const TAB_BAR_HEIGHT = 40;

type Props = {
  onPress: () => void;
  icon?: React.ReactNode;
  accessibilityLabel?: string;
  testID?: string;
  bottomOffset?: number;
  style?: StyleProp<ViewStyle>;
};

export const Fab: React.FC<Props> = ({
  onPress,
  icon,
  accessibilityLabel,
  testID,
  bottomOffset = 20 + TAB_BAR_HEIGHT,
  style,
}) => {
  const primary = useThemeColor({}, "primary");
  const onPrimary = useThemeColor({}, "onPrimary");
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[
        styles.fab,
        { backgroundColor: primary, bottom: bottomOffset },
        style,
      ]}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
      testID={testID}
    >
      {icon ?? <Ionicons name="add" size={30} color={onPrimary} />}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  fab: {
    position: "absolute",
    width: 56,
    height: 56,
    alignItems: "center",
    justifyContent: "center",
    right: 20,
    borderRadius: 28,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 4.65,
    zIndex: 10,
  },
});
